/* eslint-disable*/
export function addRequireHeader () {
    var userAgent = window.navigator.userAgent; //包含以下属性中所有或一部分的字符串：appCodeName,appName,appVersion,language,platform
    var strStart, temp, strStop;
    //FireFox
    if (userAgent.indexOf('Firefox') != -1) {
        /*broName = 'FireFox浏览器';*/
        strStart = userAgent.indexOf('Firefox');
        temp = userAgent.substring(strStart);
        return {
            browser: 'FireFox',
            version: temp
        };
    }

    //Edge
    if (userAgent.indexOf('Edge') != -1) {
        /*broName = 'Edge浏览器';*/
        strStart = userAgent.indexOf('Edge');
        temp = userAgent.substring(strStart);
        return {
            browser: 'Edge',
            version: temp
        };
    }

    //IE浏览器
    if (userAgent.indexOf('Trident') != -1) {
        /*broName = 'IE浏览器'; */
        strStart = userAgent.indexOf('rv');
        strStop = userAgent.indexOf(')');
        temp = userAgent.substring(strStart, strStop);
        return {
            browser: 'IE',
            version: temp
        };
    }

    //Chrome浏览器
    if (userAgent.indexOf('Chrome') != -1) {
        /*broName = 'Chrome浏览器';*/
        strStart = userAgent.indexOf('Chrome');
        strStop = userAgent.indexOf(' Safari');
        temp = userAgent.substring(strStart, strStop);
        return {
            browser: 'Chrome',
            version: temp
        };
    }
}
